// import { InputFactory } from "../../../../nq-component";
import BaseListPage from "../../../../base/BaseListPage";
import CustomFilterGenerator from "../../../../components/CustomFilterGenerator/CustomFilterGenerator";
import InputFactory from "../../../../components/InputFactory";
import PageContainer from "../../../../components/PageContainer/PageContainer";
import Table from "../../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import withRouter from "../../../../utils/withRouter";
import AffiliateDirectoryListPresenter from "./AffiliateDirectoryListPresenter";

class AffiliateDirectoryListPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new AffiliateDirectoryListPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      upsertUseCase(),
      deleteObjectUseCase()
    );

    this.fieldsToDisplay = [
      "firstName",
      "lastName",
      "contactNumber",
      "email",
      "position",
      // "telephoneNumber",
      "mobileNumber",
      // "faxNumber",
      "status",
    ];
  }

  componentDidMount() {
    this.presenter.componentDidMount();
  }

  getCollectionName() {
    return "users";
  }

  getActions() {
    return [
      {
        label: "Edit",
        onClick: this.onClickItem.bind(this),
        icon: "bi bi-pencil-square",
      },
    ];
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count } = this.state;

    return (
      <PageContainer
        title="Affiliate Directory"
        infiniteScroll={{
          loadMore: this.loadMore.bind(this),
          hasMore: !loading && count > objects.length,
        }}
      >
        <div className="d-flex justify-content-end mt-3">
          {Object.keys(schema.filters || {}).map((field) => {
            let { type, ...options } = schema.filters[field];
            return (
              <InputFactory
                key={field}
                className="ms-1"
                type={type}
                field={field}
                where={{}}
                onChange={this.onChangeFilter.bind(this, type)}
                {...options}
              />
            );
          })}
        </div>
        {/* <CustomFilterGenerator
          schema={schema}
          onChangeFilter={this.onChangeFilter.bind(this)}
        /> */}
        <Table
          fields={schema.fields}
          objects={objects}
          progress={loading}
          excludeFields={Object.keys(schema.fields).filter(
            (key) => !this.fieldsToDisplay.includes(key)
          )}
        />
      </PageContainer>
    );
  }
}

export default withRouter(AffiliateDirectoryListPage);
